var exports = {
  "kL": "SidebarShellSkeleton.module__container___M05YZV",
  "Kd": "SidebarShellSkeleton.module__containerMobile___M05YZV",
  "DF": "SidebarShellSkeleton.module__headerFrame___M05YZV",
  "VH": "SidebarShellSkeleton.module__headerFrameBanner___M05YZV",
  "kW": "SidebarShellSkeleton.module__headerBanner___M05YZV",
  "wx": "SidebarShellSkeleton.module__header___M05YZV",
  "D": "SidebarShellSkeleton.module__headerCaret___M05YZV",
  "Qs": "SidebarShellSkeleton.module__content___M05YZV",
};

module.exports = exports;
